import { render, staticRenderFns } from "./mamografos.vue?vue&type=template&id=42943a85&scoped=true&"
import script from "./mamografos.vue?vue&type=script&lang=js&"
export * from "./mamografos.vue?vue&type=script&lang=js&"
import style0 from "./mamografos.vue?vue&type=style&index=0&id=42943a85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42943a85",
  null
  
)

export default component.exports